module.exports = __webpack_public_path__ + "media/images/country_flags/tr-d14ea02cca4233a9f1d103dc09df696e.png";